import { createContext } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  handleLogout: () => void;
  handleLogin: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
